"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VCardBody = exports.VCardTextSpanContainer = exports.VCardTextSpan = exports.VCardHeader = exports.VCard = void 0;
var core_1 = require("@blueprintjs/core");
var styled_components_1 = __importDefault(require("styled-components"));
exports.VCard = (0, styled_components_1.default)(core_1.Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0!important;\n    ", "\n    ", "\n    \n    ", "\n"], ["\n    padding: 0!important;\n    ", "\n    ", "\n    \n    ", "\n"])), function (props) {
    return props.collapse === 'true'
        ? "\n    transition-property: height;\n    transition-duration: ".concat(props.transitionduration || '200', "ms;\n    ")
        : '';
}, function (props) {
    return props.collapse === 'true' && props.isopen === 'false'
        ? "height: 35px;"
        : props.collapse === 'true' && props.isopen === 'true'
            ? "height: ".concat(props.height, ";")
            : props.collapse !== 'true'
                ? "height: ".concat(props.height, ";")
                : '';
}, function (props) { return (props.width ? "width: ".concat(props.width, ";") : ''); });
exports.VCardHeader = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 3px 3px 0 0;\n  flex-direction: ", ";\n  background: ", ";\n  justify-content: ", ";\n  height: ", ";\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n  width: 100%;\n  position: relative;\n"], ["\n  border-radius: 3px 3px 0 0;\n  flex-direction: ", ";\n  background: ", ";\n  justify-content: ", ";\n  height: ", ";\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n  width: 100%;\n  position: relative;\n"])), function (props) {
    return props.headerOrientation || 'row';
}, function (props) {
    return props.headerBackgroundColor || '#E8E8E8';
}, function (props) {
    return props.headerJustifyContent === 'center'
        ? 'center'
        : props.headerJustifyContent === 'end'
            ? 'flex-end'
            : 'flex-start';
}, function (props) {
    return props.heigthHeaderPx ? "".concat(props.heigthHeaderPx, "px") : '35px';
});
exports.VCardTextSpan = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 100%;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: ", ";\n  & span {\n    margin: 0 5px 0 0;\n    font-weight: ", ";\n    text-transform: ", ";\n  }\n"], ["\n  height: 100%;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: ", ";\n  & span {\n    margin: 0 5px 0 0;\n    font-weight: ", ";\n    text-transform: ", ";\n  }\n"])), function (props) { return props.headerColor || '#5D5D5D'; }, function (props) {
    return props.headerTextJustify === 'center'
        ? 'center'
        : props.headerTextJustify === 'end'
            ? 'flex-end'
            : 'flex-start';
}, function (props) {
    return props.headerTextBold ? 600 : 400;
}, function (props) {
    return props.headerTextUppercase && 'uppercase';
});
exports.VCardTextSpanContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: 1;\n  width: 100%;\n"], ["\n  flex: 1;\n  width: 100%;\n"])));
exports.VCardBody = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  height: calc(100% - 35px);\n  background: ", ";\n  padding: ", ";\n"], ["\n  height: calc(100% - 35px);\n  background: ", ";\n  padding: ", ";\n"])), function (props) {
    return props.backgroundColor || 'transparent';
}, function (props) { return props.bodyPadding || '15px'; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
